import React, { useEffect } from "react";
import Typed from "typed.js";
import { logo } from "../../constants/home";
import { Link } from "react-router-dom";
import About from "../about/About";
import trax2 from "../../assets/png/pheaktra-profile.jpg";
import Portfolio from "../portfolio/Portfolio";
import { motion } from "framer-motion";
import Tool from "../tool/Tool";

const HomePage = () => {
  useEffect(() => {
    const options = {
      strings: ["Web Developer", "UX/UI Designer", "Graphic Designer"],
      typeSpeed: 130,
      backSpeed: 40,
      backDelay: 1000,
      loop: true,
    };
    const typed = new Typed(".animation", options);
    return () => typed.destroy();
  }, []);

  return (
    <div className="container-fluid p-0 m-0">
      <section className="position-relative hero-section d-flex align-items-center justify-content-center">
        <div className="position-absolute top-0 start-0 w-100 h-100 z-0"></div>
        <div className="container position-relative z-1 py-5">
          <div className="row align-items-center justify-content-center g-4 flex-column-reverse flex-lg-row">
            <div className="col-12 col-lg-6 text-center text-lg-start">
              <div className="mb-4 mt-sm-5">
                <h1 className="fw-bold mb-3">
                  <span className="fs-3">I'm</span>
                  <br />
                  <span>Ry Pheaktra</span>
                </h1>
                <div className="typed-container mb-3">
                  <span className="animation typed-text"></span>
                </div>
                <p className="fs-5">
                  Hello, I'm PheakTra, a passionate Web-Developer specializing
                  in crafting responsive, user-friendly, and visually appealing
                  websites. Welcome to my portfolio, where creativity meets
                  functionality!
                </p>
              </div>
            </div>
            <motion.div
              className="col-12 col-md-8 col-lg-6 text-center mt-5"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
            >
              <img
                className="img-fluid rounded-4 w-75 w-md-100"
                src={trax2}
                alt="Pheaktra"
              />
              <div className="d-none d-md-block">
                {logo.map((items, index) => (
                  <Link
                    target="_blank"
                    to={items.path}
                    className="style-socail mt-md-3"
                    key={index}
                  >
                    <span className="icon">{items.icons}</span>
                    <span className="title-socail">{items.title}</span>
                  </Link>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <div>
        <About />
      </div>
      <div className="container">
        <Tool />
      </div>
      <div>
        <Portfolio />
      </div>
    </div>
  );
};

export default HomePage;
